<script setup lang="ts">
import Product from '@/api/Product'
import ProductCard from '@/components/common/ProductCard.vue'
import ProductCardSkeleton from '@/components/common/skeleton/ProductCardSkeleton.vue'
import { useArray } from '@/composables/array'
import { AppSection } from 'lilasia-ui'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  productId: number
}>()

const { shuffle } = useArray()
const { t } = useI18n()

const products = ref<Product[]>([])
const loading = ref(true)

onMounted(async () => {
  products.value = await Product.related<Product[]>(props.productId)
  products.value = shuffle(products.value).slice(0, 10)
  loading.value = false
})
</script>

<template>
  <AppSection>
    <div
      v-if="products && products.length > 0"
      class="space-y-16"
    >
      <h2 class="text-24 font-600 leading-32">{{ t('similar_items') }}</h2>
      <div class="grid grid-cols-2 gap-16 md:grid-cols-4 lg:grid-cols-5">
        <ProductCard
          v-for="(product, index) in products"
          :key="index"
          :product="product"
        />
      </div>
    </div>

    <div
      v-else-if="loading"
      class="grid grid-cols-2 gap-16 md:grid-cols-4 lg:grid-cols-5"
    >
      <ProductCardSkeleton
        v-for="n in 10"
        :key="n"
      />
    </div>
  </AppSection>
</template>
